import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { User, UserRole } from '../../domain/domain';
import NotFound from '../NotFound';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ApplicationState } from '../../reducers';
import EditorialTemplateEditor from './EditorialTemplateEditor';
import EditorialTemplatesList from './EditorialTemplatesList';

type Props = {
    currentUser: User
}

const useStyles = makeStyles(_ => ({
    root: {
        maxWidth: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 20
    },
    columnTitle: {
        fontWeight: 'bold'
    },
    select: {
        width: 200
    }
}));

const EditorialTemplatesPage : React.FC<Props> = ({currentUser}) => {
    
    const classes = useStyles();

    if (currentUser.userRole !== UserRole.ADMINISTRATOR) {
        return <NotFound />
    }

    return (
        <Grid container direction='column' className={classes.root} alignItems="stretch" spacing={4}>
            <Grid item>
                <Link to='/admin'>Administrator Page</Link>
            </Grid>
            <Grid item>
                <Grid container direction='row' wrap='nowrap' spacing={3}>
                    <Grid item style={{width: 300, minWidth: 300, maxWidth: 300}}>
                        <EditorialTemplatesList />
                    </Grid>
                    <Grid item style={{flexGrow: 1}}>
                        <EditorialTemplateEditor />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        currentUser: state.user.currentUser
    };
};

export default compose<any>(
    connect(mapStateToProps, null)
)(EditorialTemplatesPage);